import { Component, OnInit } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { Persona } from 'se-resource-types/dist/lib/UserService'

const exampleHtml = `
<se-po-persona-avatar
  avatarDataSize="200"
  headerDataSize="600"
  [persona]="persona">
</se-po-persona-avatar>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { Persona } from 'se-resource-types/dist/lib/UserService'
export class PersonaAvatarSizeExampleComponent implements OnInit {
  public persona: Persona
  public ngOnInit(): void {
    this.persona = {
      id: 8,
      date_of_birth: '2007-01-01',
      first_name:'Also',
      gender: 'male',
      last_name: 'Test'
    } as Persona
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-avatar-size-example',
  template,
  styleUrls: ['./../persona-avatar-docs.component.scss'],
  standalone: false,
})
export class PersonaAvatarSizeExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public persona: Persona

  public ngOnInit(): void {
    this.persona = {
      id: 8,
      date_of_birth: '2007-01-01',
      first_name:'Also',
      gender: 'male',
      last_name: 'Test'
    } as Persona
  }
}
